import {Module} from 'vuex';
import {DisplayOption} from '@/components/interfaces/ComponentOptions';
import {getBillboardCities, getStatuses} from '@/sports-schedule/EventService';

interface EventState {
    statuses: DisplayOption[];
    billboardCities: DisplayOption[];
}

export default {
    namespaced: true,
    state: {
        statuses: [],
        billboardCities: []
    },
    actions: {
        async loadReferenceData({commit, state}): Promise<void> {
            // Loads all reference data asynchronously.
            // Loads all at the same time so it is O(1) rather than O(n).
            // This makes a big difference for the initial load when it has to call the server for each reference type.
            // The normal case is either all will be loaded or none will but this isn't a guarantee
            const promises: Promise<any>[] = [];
            // Push the promise for each type that hasn't yet been loaded with a unique (arbitrary) type
            if (state.statuses.length === 0) {
                promises.push(getStatuses().then(statuses => ({ id: 2, results: statuses })));
            }
            if (state.billboardCities.length === 0) {
                promises.push(getBillboardCities().then(billboardCities => ({id: 4, results: billboardCities})));
            }

            // When all are complete set the data for each type that returned data.
            (await Promise.all(promises)).forEach(result => {
                switch (result.id) {
                    case 2:
                        commit('setStatuses', result.results);
                        break;
                    case 4:
                        commit('setBillboardCities', result.results);
                        break;
                }
            });
        }
    },
    mutations: {
        setStatuses(state, payload: DisplayOption[]) {
            state.statuses = payload;
        },
        setBillboardCities(state, payload: DisplayOption[]) {
            state.billboardCities = payload;
        }
    },
} as Module<EventState, any>;
